// 金牌医生预约

export default [
  {
    path: '/appointment/',
    component: () => import('@/views/doctorAppointment/index.vue'),
    children: [
      {
        path: '',
        redirect: '/appointment/doctor'
      },
      {
        path: 'doctor', // 金牌医生首页
        name: 'doctor',
        component: () => {
          return import(
            /* webpackChunkName: "doctorAppointment" */ '@/views/doctorAppointment/home.vue'
          )
        },
        meta: {
          keepAlive: true
        }
      },
      {
        path: 'appointSelection', // 医生选择
        name: 'appointSelection',
        component: () => {
          return import(
            /* webpackChunkName: "doctorAppointment" */ '@/views/doctorAppointment/appointSelection.vue'
          )
        },
        meta: {
          keepAlive: true
        }
      },
      {
        path: 'doctorList', // 医生列表
        name: 'doctorList',
        component: () => {
          return import(
            /* webpackChunkName: "doctorAppointment" */ '@/views/doctorAppointment/doctorList.vue'
          )
        }
      },
      {
        path: 'doctorDetail', // 医生详情
        name: 'doctorDetail',
        component: () => {
          return import(
            /* webpackChunkName: "doctorAppointment" */ '@/views/doctorAppointment/doctorDetail.vue'
          )
        }
      },
      {
        path: 'appointList', // 已预约列表
        name: 'appointList',
        component: () => {
          return import(
            /* webpackChunkName: "doctorAppointment" */ '@/views/doctorAppointment/appointList.vue'
          )
        }
      },
      {
        path: 'appointDetail', // 预约详情
        name: 'appointDetail',
        component: () => {
          return import(
            /* webpackChunkName: "doctorAppointment" */ '@/views/doctorAppointment/appointDetail.vue'
          )
        }
      }
    ]
  }
]
